import React, { useEffect, useState } from "react";
import classes from "../Store.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PixIconWhite from "../../../../assets/images/icon_pix_white.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import * as r from "../../../../constants/routes";
import * as api from "../../../../constants/api";
import useFetch from "../../../../hooks/useFetch";

interface SuccessCardProps {
  qntOfJourneys: number;
  productInfo: { price: number }[];
  pixInfo: any;
  productChoosed: number;
}

const SuccessCard: React.FC<SuccessCardProps> = ({
  qntOfJourneys,
  productInfo,
  pixInfo,
  productChoosed
}) => {
  const { t } = useTranslation();
  const history = useNavigate();

  // Hook customizado para buscar dados das invoices
  const [invoiceData, isLoadingInvoices, errorInvoices, fetchInvoices]: any =
    useFetch({
      autoInit: false,
    });

  // Estado que guarda a URL do PDF da nota fiscal
  const [invoicePdfUrl, setInvoicePdfUrl] = useState<string | null>(null);

  // Pega o ID do pedido vindo do PIX
  const orderId = pixInfo?.orderID;

  // Verifica se a invoice NÃO existe ou ainda não tem URL
  // cobre null, undefined ou vazio
  const invoiceNull = !invoiceData?.invoices?.[0]?.print_url;

  //  Executa quando o orderId estiver disponível
  useEffect(() => {
    if (!orderId) return;

    fetchInvoices({
      method: "GET",
      url: api.GET_INVOICES_URL(1, 1, "bill", orderId),
      onSuccess: (data: any) => {},
      onError: (error: any) => {
        console.error("Erro ao obter informações do produto:", error);
      },
    });
  }, [orderId]);

  //Sempre que invoiceData mudar, atualiza o estado
  useEffect(() => {
    if (!invoiceData) return;

    const invoice = invoiceData?.invoices?.[0];
    const url = invoice?.print_url;

    setInvoicePdfUrl(url);
  }, [invoiceData]);

  return (
    <div className={classes.CompleteOperation}>
      <div className={classes.CompleteOperationDetails}>
        <h2>{t("purchase.complete_operation")}</h2>
        <p>{t("purchase.congratulations")}</p>
        <h4>{t("purchase.purchase_details")}</h4>
        <div className={classes.InfosDetailsOperation}>
          <div>
            {qntOfJourneys} {t("global.smart_journey")}
          </div>
          <div className={classes.InfosAndInvoiceNote}>
            <div className={classes.InfosAndInvoicePrice}>
              <div>
                <img src={PixIconWhite} alt="" />
              </div>
              <div>
                <p>Pix</p>
                <p>
                  R$ {productInfo?.[productChoosed].price?.toFixed(2).replace(".", ",")}
                </p>
              </div>
            </div>

            {/* Só mostra o botão se existir nota fiscal */}
            {invoiceNull ? null : (
              <div
                className={classes.InfosNf}
                onClick={() => {
                  if (invoicePdfUrl) {
                    window.open(invoicePdfUrl, "_blank");
                  }
                }}
              >
                <PictureAsPdfIcon sx={{ fontSize: 40 }} />
                <div>
                  <p>Abrir</p>
                  <p>NF-e</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Mensagem dependendo da existência da nota */}
        <div className={classes.InfosInvoiceExtra}>
          {invoiceNull ? (
            <p>{t("purchase.the_invoice_has_not_yet_been_generated")}</p>
          ) : (
            <p>{t("purchase.invoice_sent_email")}</p>
          )}

          {/* Será implementado quando tiver o componente de listagem das compras */}
          {/*<div className={classes.InfosHistoryLink}>
                <ul>
                    <li>{t("purchase.check_your_past_purchases")} <span>{t("purchase.clicking_here")}</span>
                    </li>
                </ul>
            </div> */}
        </div>
      </div>
      <p>
        {t("purchase.if_you_have_any_questions")}{" "}
        <span>atendimento@probrain.com.br</span>
      </p>

      <div className={classes.CompleteOperationButton}>
        <RoundButton
          onClick={() => history(r.R_A_ROOT)}
          text={t("global.go_back_to_home")}
          title={t("global.go_back_to_home")}
        />
      </div>
    </div>
  );
};

export default SuccessCard;
